<template>
  <div class="AddPubEngineeringBox">
    <div class="head">
      <el-breadcrumb style="margin: auto auto auto 20px;" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'ProcessPubEngineering' }">公用工程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
        size="small" style="width: 55%; margin-left: 15%">
        <el-form-item label="公用工程编号" prop="number">
          <el-input v-model="ruleForm.number" />
        </el-form-item>
        <el-form-item label="公用工程名称" prop="name">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="公用工程位置" prop="place">
          <el-input v-model="ruleForm.place" />
        </el-form-item>
        <el-form-item label="公用工程类型" prop="type">
          <el-input v-model="ruleForm.type" />
        </el-form-item>
        <el-form-item label="公用工程功能" prop="functionality">
          <el-input v-model="ruleForm.functionality" />
        </el-form-item>
        <el-form-item label="主要介质" prop="neurogen">
          <el-input v-model="ruleForm.neurogen" />
        </el-form-item>
        <el-form-item label="主要设备设施" prop="facility">
          <el-input v-model="ruleForm.facility" />
        </el-form-item>
        <el-form-item label="周围环境" prop="environment">
          <el-input v-model="ruleForm.environment" />
        </el-form-item>
        <el-form-item label="应急处置方法" prop="meetEmergencies">
          <el-input v-model="ruleForm.meetEmergencies" />
        </el-form-item>
        <el-form-item label="自动化控制方式">
          <el-input v-model="ruleForm.automationControl" />
        </el-form-item>
        <el-form-item label="相关照片">
          <el-upload
            class="avatar-uploader"
            action="/v1/trainMaterials/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess">
            <img v-if="ruleForm.pictureUrl" :src="host + ruleForm.pictureUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
<!--        <el-form-item label="" label-width="0" style="margin-bottom: 15px">
          <el-col :span="12">
            <el-form-item label="经度（度）" prop="longitude">
              <el-input v-model="ruleForm.longitude" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度（度）" prop="latitude">
              <el-input v-model="ruleForm.latitude" />
            </el-form-item>
          </el-col>
        </el-form-item>-->
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { pubEngineeringAdd, pubEngineeringEdit } from '@/api/processManager'
export default {
  name: 'AddPubEngineering',
  data() {
    return {
      ruleForm: {},
      rules: {
        number: [{ required: true, message: '请输入公用工程编号' }],
        name: [{ required: true, message: '请输入公用工程名称' }],
        place: [{ required: true, message: '请输入公用工程位置' }],
        type: [{ required: true, message: '请输入公用工程类型' }],
        functionality: [{ required: true, message: '请输入公用工程功能' }],
        neurogen: [{ required: true, message: '请输入主要介质' }],
        facility: [{ required: true, message: '请输入主要设备设施' }],
        environment: [{ required: true, message: '请输入周围环境' }],
        meetEmergencies: [{ required: true, message: '请输入应急处置方法' }],
        /*longitude: [{ required: true, message: '请输入经度' }],
        latitude: [{ required: true, message: '请输入纬度' }],*/
      }
    }
  },
  created() {
    if(this.$route.params.key) {
      this.ruleForm = this.$route.params.key
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.$set(this.ruleForm, 'pictureUrl', res.data)
    },
    // 保存
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 编辑
          if(this.$route.params.key) {
            pubEngineeringEdit({ ...this.ruleForm }).then(res => {
              this.$message.success('编辑成功')
              this.$router.push('ProcessPubEngineering')
            })
          }
          // 新增
          else {
            pubEngineeringAdd({ ...this.ruleForm }).then(res => {
              this.$message.success('新增成功')
              this.$router.push('ProcessPubEngineering')
            })
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.AddPubEngineeringBox /deep/ .el-form-item {
  margin-bottom: 25px
}
</style>